module.exports = __webpack_public_path__ + "img/chara-head-0.34fda782.png";